import PropTypes from 'prop-types';
export const QuickFiltersValueDisplayUses = Object.freeze({
  STRING: 'STRING',
  TAGS: 'TAGS'
});
export const QuickFiltersValueDisplayUsePropType = PropTypes.oneOf(Object.values(QuickFiltersValueDisplayUses));